module.exports = __webpack_public_path__ + "static/ios-7fba4fffa9fbf6ba53a3540e2a737749.svg";